import { EnumPriceTierDiscountUnit, PriceTier } from "gql/generated";

export const getDiscountedTierPrice = (tier: PriceTier) => {
  const { discountAmount, discountUnit } = tier;

  if (!discountAmount || !discountUnit) {
    return tier.price;
  }

  if (discountUnit === EnumPriceTierDiscountUnit.Percentage) {
    const discountedPrice = tier.price * discountAmount; // discountAmount is a decimal point value between 0 and 1
    return Math.max(0, discountedPrice);
  } else if (discountUnit === EnumPriceTierDiscountUnit.Fixed) {
    const discountedPrice = tier.price - discountAmount; // discountAmount is a fixed value in cents
    return Math.max(0, discountedPrice);
  } else return tier.price;
};
